export default "__VITE_ASSET__B$NV6NSt__"